import { useCallback } from "react";
import { useGeometryEditor } from "../../../../../components/GeometryEditor/useGeometryEditor";
import { useEditCoordinatesDialog } from "../../../../../hooks/useDialogs";

export const useFeatureEditCoordinates = () => {
  const openEditCoordinatesDialog = useEditCoordinatesDialog();
  const [{ geometry, geometryType, crs }, { editGeometry }] = useGeometryEditor();

  return useCallback(() => {
    openEditCoordinatesDialog([], {
      geometry,
      geometryType,
      editGeometry,
      geometryTypeChoiceDisabled: true,
      crs,
    });
  }, [geometry, geometryType, editGeometry, openEditCoordinatesDialog, crs]);
};
